import React from 'react'
import Dotdotdot from 'react-dotdotdot'
import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import classNames from 'classnames'
import {
  LanguageUtils,
  type Nil,
  Text,
  type WellnessPlanBenefit,
} from '@pbt/pbt-ui-components'
import { Check as CheckIcon } from '@pbt/pbt-ui-components/src/icons'

import { getCurrentBusinessButtonsColor } from '~/store/reducers/auth'

const useStyles = makeStyles(
  (theme) => ({
    root: {
      cursor: 'pointer',
      height: 40,
      backgroundColor: theme.colors.tableBackground,
      '&:nth-of-type(odd)': {
        backgroundColor: theme.colors.tableOddRowBackground,
      },
    },
    check: {
      marginRight: theme.spacing(2),
      color: ({ buttonsColor }: UseStylesProps) =>
        buttonsColor || theme.colors.alertLabelError,
    },
  }),
  { name: 'WellnessPlanBenefitRow' },
)

export interface WellnessPlanBenefitRowProps {
  benefit: WellnessPlanBenefit
  className?: string
  name?: string
}

interface UseStylesProps {
  buttonsColor: string | Nil
}

const WellnessPlanBenefitRow = ({
  className,
  name,
  benefit,
}: WellnessPlanBenefitRowProps) => {
  const buttonsColor = useSelector(getCurrentBusinessButtonsColor)
  const stylesProps: UseStylesProps = {
    buttonsColor,
  }
  const classes = useStyles(stylesProps)

  return (
    <Grid
      container
      item
      alignItems="center"
      className={classNames(className, classes.root)}
      px={3}
      py={1}
      wrap="nowrap"
    >
      <CheckIcon className={classes.check} />
      <Dotdotdot clamp={1}>
        <Text variant="body">
          {name || LanguageUtils.getTranslatedFieldName(benefit)}
        </Text>
      </Dotdotdot>
    </Grid>
  )
}

export default WellnessPlanBenefitRow
